module.exports = __webpack_public_path__ + "66ba38d7.svg";